'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _react = require('react');

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _Container2 = require('./Container');

var _Container3 = _interopRequireDefault(_Container2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Handler = function (_Container) {
    _inherits(Handler, _Container);

    function Handler() {
        _classCallCheck(this, Handler);

        return _possibleConstructorReturn(this, (Handler.__proto__ || Object.getPrototypeOf(Handler)).apply(this, arguments));
    }

    _createClass(Handler, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _get(Handler.prototype.__proto__ || Object.getPrototypeOf(Handler.prototype), 'componentDidMount', this) && _get(Handler.prototype.__proto__ || Object.getPrototypeOf(Handler.prototype), 'componentDidMount', this).call(this);
            //Adapted from react router Lifecycle mixin
            if (this.routerWillLeave) {
                var route = this.props.route || this.context.route;
                !route ? process.env.NODE_ENV !== 'production' ? (0, _invariant2.default)(false, 'missing route') : (0, _invariant2.default)(false) : undefined;
                this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            _get(Handler.prototype.__proto__ || Object.getPrototypeOf(Handler.prototype), 'componentWillUnmount', this) && _get(Handler.prototype.__proto__ || Object.getPrototypeOf(Handler.prototype), 'componentWillUnmount', this).call(this);
            //Taken from react router Lifecycle mixin
            this._unlistenBeforeLeavingRoute && this._unlistenBeforeLeavingRoute();
        }
    }, {
        key: 'setLeftNavBarButtonDisabled',
        value: function setLeftNavBarButtonDisabled(disabled) {
            //Native only
        }
    }, {
        key: 'setRightNavBarButtonDisabled',
        value: function setRightNavBarButtonDisabled(disabled) {
            //Native only
        }
    }, {
        key: 'setTitle',
        value: function setTitle(title, subtitle) {
            //Native only
        }
    }, {
        key: 'setRightButton',
        value: function setRightButton(button) {
            //Native only
        }
    }, {
        key: 'renderComponent',
        value: function renderComponent() {
            return this.renderHandler();
        }
    }]);

    return Handler;
}(_Container3.default);

exports.default = Handler;

Handler.contextTypes = {
    history: _react.PropTypes.object,
    route: _react.PropTypes.object
};
Handler.propTypes = {
    route: _react.PropTypes.object
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-component-web/dist/Handler.js
 ** module id = 614
 ** module chunks = 0
 **/